import React from 'react';
import { Content } from './shared';

const CignaFluShot = () => (
  <Content>
    Visit the Cigna website for the 80+ clinics and pharmacies that offer free flu shots.
    <ol>
      <li>Visit the Cigna website.</li>

      <li>
        Go to Individuals and Families {'>'} Member Resources {'>'} Where to Get Your Flu Shot.
      </li>
    </ol>
    Note: Be sure to confirm with the provider that they accept your medical plan before receiving
    services.
  </Content>
);

export default CignaFluShot;
